// removed by extract-text-webpack-plugin
module.exports = {"vpDisplayImageContainer":"vpDisplayImageContainer___23Dw1","vpImage":"vpImage___utIEl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/ImageElement.module.less
// module id = 2869
// module chunks = 29